import { render, staticRenderFns } from "./DesigningForHeader.vue?vue&type=template&id=3540d269"
import script from "./DesigningForHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./DesigningForHeader.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports